export default __webpack_public_path__ + "static/media/ind_crisis.c650941c.png";